<template>
  <div aria-live="assertive">
    <span v-if="message" v-text="message" class="sr-only"></span>
    <span v-else v-html="'&nbsp;'" class="sr-only"></span>
  </div>
</template>

<script>
export default {
  name: "AriaLiveRegion",
  props: {
    message: {
      type: String,
      required: true
    }
  }
}
</script>
